<template>
  <div class="page-pay-notify-vip">
    <div class="page-pay-notify-vip-img">
      <ym-img class="img"
              :src="pageData.product.src"
              alt="产品图片"
      />
    </div>
    <router-link :to="primaryBtn.url">
      <ym-button type="gradient-black-column"
                 size="large"
                 round
      >
        {{ primaryBtn.hint }}
      </ym-button>
    </router-link>
    <router-link v-if="share"
                 class="page-pay-notify-vip-entrance"
                 :to="{ name: 'MyVipCenter' }"
    >
      {{ enterMyVipHint }}
    </router-link>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';

  export default {
    name: 'PayNotifyVip',
    metaInfo() {
      return {
        title: this.pageData.title,
      };
    },
    components: {
      'ym-button': Button,
    },
    props: {
      pageData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        enterMyVipHint: '进入会员中心',
      };
    },
    computed: {
      id() {
        return this.pageData.product.id;
      },
      share() {
        const { render = {} } = this.pageData;
        return render.share;
      },
      primaryBtn() {
        const { share } = this;
        if (share != null) return share;
        return {
          hint: this.enterMyVipHint,
          url: { name: 'MyVipCenter' },
        };
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-pay-notify-vip {
    box-sizing: border-box;
    height: 100%;
    padding: @size-medium @size-extra-medium;
    line-height: 1;
    background: @background-color-base;

    &-img {
      margin-bottom: @size-medium;
    }

    &-entrance {
      display: block;
      margin-top: @size-base;
      font-size: @font-size-medium;
      color: @color-text-light;
      text-align: center;
    }
  }
</style>
